import {Alert, Button, TextInput} from "omoplay";
import OMOPlayQR from "../../assets/images/omoplay_qr_code.png";


const TargetMessageForm = ({onChangePhoneNumber}) => {

    return (
        <div className="flex-col gap-[32px]">
            <div className="font-semibold text-[20px]">Step 1. 오모플레이 채널 친구맺기</div>
            <div className="flex-col flex-center-all gap-[16px]">
                <Button variants="primary" value="채널 친구 추가하러 가기" onClick={() => window.location.href = "https://pf.kakao.com/_cDjhn"} />
                <div>or</div>
                <img src={OMOPlayQR} alt="omoplay_qr" width="92" height="92" />
                <div className="text-center">
                    메시지를 수신하려는 모바일 폰에서 QR을 스캔하고<br/>
                    오모플레이 채널과 친구 맺기를 완료하세요
                </div>
            </div>
            <div className="font-semibold text-[20px]">Step 2. 메시지를 받을 전화번호 입력</div>
            <TextInput placeholder="전화번호 입력" onChange={(e) => onChangePhoneNumber(e.target.value)} />
            <Alert withIcon={true} type="warning" title="유의사항">
                <li>오후 9시부터 오전 8시까지는 메시지를 전송할 수 없습니다.</li>
                <li>오모플레이 채널과 친구 추가를 해야 메시지를 확인할 수 있습니다.</li>
                <li>동일한 휴대전화로 여러번 보낼 경우 발송이 되지 않을 수 있습니다.</li>
            </Alert>
        </div>
    )
}

export default TargetMessageForm